import React from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';

const UserLayout = () => {
  const { user, isAuthenticated, logout, userRole } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

    const isUser = userRole === 'user';
    const isAdmin = userRole === 'admin';
    const isOrganizer = userRole === 'organizer';
    const isAgent = userRole === 'agent';



    const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
        <header className="sticky top-0 z-50 bg-white shadow-sm">
            <nav className="container mx-auto px-0 py-3">
                <div className="flex items-center justify-between">
                    <Link to="/" className="text-2xl nav-link font-bold text-yellow-400 hover:!text-yellow-500">
                        <img src={`${process.env.PUBLIC_URL}/ticketaty-logo.svg`}  className="h-8 w-auto hover:opacity-90" alt="Ticketaty" />
                    </Link>

                    {/* Desktop links */}
                    <div className="hidden md:flex space-x-6">
                        <Link to="/" className="text-gray-900 nav-link hover:!text-yellow-400">Events</Link>
                        <Link to="/why-Ticketaty" className="text-gray-900 nav-link hover:!text-yellow-400">Ticketaty</Link>
                        {isAuthenticated && isUser && (
                            <>
                                <Link to="/my-tickets" className="text-gray-900 nav-link hover:!text-yellow-400">My Tickets</Link>
                                <Link to="/my-orders" className="text-gray-900 nav-link hover:!text-yellow-400">My Orders</Link>
                            </>
                        )}
                    </div>

                    {/* Desktop auth buttons */}
                    <div className="hidden md:flex items-center space-x-4">
                        {isAuthenticated ? (
                            <>
                                {isUser && (
                                    <Link
                                        to="/profile"
                                        className="text-gray-900 nav-link hover:!text-yellow-400"
                                    >
                                        {user?.first_name || 'Profile'}
                                    </Link>
                                )}
                                {isAuthenticated && isAdmin && (
                                    <Link
                                        to="/admin/dashboard"
                                        className="text-gray-900 nav-link hover:!text-yellow-400"
                                    >
                                        Dashboard
                                    </Link>
                                )}

                                {isAuthenticated && isOrganizer && (
                                    <Link
                                        to="/organizer/dashboard"
                                        className="text-gray-900 nav-link hover:!text-yellow-400"
                                    >
                                        Dashboard
                                    </Link>
                                )}

                                {isAuthenticated && isAgent && (
                                    <Link
                                        to="/agent/dashboard"
                                        className="text-gray-900 nav-link hover:!text-yellow-400"
                                    >
                                        Dashboard
                                    </Link>
                                )}
                                <button
                                    onClick={handleLogout}
                                    className="bg-yellow-400 text-white px-4 py-2 rounded-lg hover:bg-yellow-500"
                                >
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className="nav-link text-gray-900 hover:!text-yellow-400">
                                    Login
                                </Link>
                                <Link to="/register" className="nav-link bg-yellow-400 text-white px-4 py-2 border-2 border-yellow-400 rounded-lg hover:bg-white hover:!text-yellow-400">
                                    Register
                                </Link>
                            </>
                        )}
                    </div>

                    {/* Burger button */}
                    <button
                        className="md:hidden"
                        onClick={() => setMenuOpen(!menuOpen)}
                    >
                        <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d={menuOpen
                                    ? "M6 18L18 6M6 6l12 12"
                                    : "M4 6h16M4 12h16M4 18h16"}
                            />
                        </svg>
                    </button>
                </div>

                {/* Mobile menu */}
                {menuOpen && (
                    <div className="md:hidden mt-4 space-y-4 border-t pt-4">
                        <Link to="/" onClick={() => setMenuOpen(false)} className="block nav-link">
                            Events
                        </Link>
                        <Link to="/why-Ticketaty" onClick={() => setMenuOpen(false)} className="block nav-link">
                            Ticketaty
                        </Link>

                        {isAuthenticated && isUser && (
                            <>
                                <Link to="/my-tickets" onClick={() => setMenuOpen(false)} className="block nav-link">
                                    My Tickets
                                </Link>
                                <Link to="/my-orders" onClick={() => setMenuOpen(false)} className="block nav-link">
                                    My Orders
                                </Link>
                            </>
                        )}

                        {isAuthenticated && isAdmin && (
                            <Link
                                to="/admin/dashboard"
                                onClick={() => setMenuOpen(false)}
                                className="block nav-link"
                            >
                                Dashboard
                            </Link>
                        )}

                        {isAuthenticated && isOrganizer && (
                            <Link
                                to="/organizer/dashboard"
                                onClick={() => setMenuOpen(false)}
                                className="block nav-link"
                            >
                                Dashboard
                            </Link>
                        )}

                        {isAuthenticated && isAgent && (
                            <Link
                                to="/agent/dashboard"
                                onClick={() => setMenuOpen(false)}
                                className="block nav-link"
                            >
                                Dashboard
                            </Link>
                        )}

                        {isAuthenticated ? (
                            <>
                                {isUser && (
                                <Link to="/profile" onClick={() => setMenuOpen(false)} className="block nav-link">
                                    {user?.first_name || 'Profile'}
                                </Link> )}
                                <button
                                    onClick={() => {
                                        handleLogout();
                                        setMenuOpen(false);
                                    }}
                                    className="ml-3 bg-yellow-400 text-white px-4 py-2 rounded-lg hover:bg-yellow-500"
                                >
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" onClick={() => setMenuOpen(false)} className="block nav-link">
                                    Login
                                </Link>
                                <Link to="/register" onClick={() => setMenuOpen(false)} className="block nav-link">
                                    Register
                                </Link>
                            </>
                        )}
                    </div>
                )}
            </nav>
        </header>

      {/* Main Content */}
      <main>
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-gray-900 text-white ">
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4 text-yellow-400">Ticketaty</h3>
              <p className="text-gray-400">Your gateway to amazing events</p>
            </div>
            <div>
              <h4 className="font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/events" className="text-gray-400 hover:text-white">Browse Events</Link></li>
                <li><Link to="/organizer/login" className="text-gray-400 hover:text-white">Organizer Login</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-4">Contact</h4>
              <p className="text-yellow-400"><span className="text-white">Email:</span> info@Ticketaty.com</p>
              <p className="text-yellow-400"><span className="text-white">Phone:</span> +1 234 567 890</p>
            </div>
          </div>
          <div className="border-t border-white mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 Ticketaty. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default UserLayout;

